/* eslint-disable react/display-name */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
// import useKfoneTranslation from '@/hooks/useTranslation';
//import { Common } from '@/model/enums';
import { API_TIMEOUT } from "constants/app.constants";
import {
  IDLE_TIME,
  IDLE_TIME_LEFT,
  REFRESH_AUTH_TOKEN_INTERVEL
} from "constants/common.constants";
import { ENV_VARS } from "constants/environment.constants";
import { SESSION_STORAGE_VAR } from "constants/session-variables.constants";
import { ODSModal } from "kfone-component-library";
import { ButtonTheme } from "kfone-component-library/enums";
import { kf1AuthenticatedHttpClient } from "kfone-frontend-core";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch } from "react-redux";
import { KfSessionBaggageInterceptor } from "services/datadog";
import { refreshAuthToken } from "services/Service";
import { usePeerGroupsStore } from "store/peer-groups";
import { resetStateClient } from "store/slices/clientSelectionSlice";
import { resetConfigState } from "store/slices/configSlice";
import { resetState } from "store/slices/countryDetailsSlice";
import { resetCurrencyState } from "store/slices/currencyDetailsSlice";
import { resetState as resetFilterState } from "store/slices/filtersSlice";
import { resetReportDetailsState } from "store/slices/jobPricingDetailsSlice";
import { resetReportSearchState } from "store/slices/jobPricingSearchSlice";
import { resetJobPricingState } from "store/slices/jobPricingSlice";
import { resetState as resetReportsState } from "store/slices/reportsSlice";
import {
  resetFilters,
  resetFiltersCount,
  resetJobCatogery,
  resetJobPricingList,
  resetPeerGroupId,
  resetSearchKey
} from "store/slices/SJPR/listSlice";
import { resetState as resetUserState } from "store/slices/userSlice";

const timeLeftInSeconds = IDLE_TIME_LEFT * 60; // 5 minutes in seconds
export enum SessionExpired {
  SESSION_EXPIRED = "kf1-sessionExpired"
}

const withSessionManager = <P extends JSX.IntrinsicAttributes>(
  WrappedComponent: React.ComponentType<P>
) => {
  return (props: P) => {
    const [showModal, setShowModal] = useState(false);
    const [timeLeft, setTimeLeft] = useState(timeLeftInSeconds);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { resetPeerGroups } = usePeerGroupsStore();

    useEffect(() => {
      const isSessionExpired = sessionStorage.getItem(
        SessionExpired.SESSION_EXPIRED
      );
      if (isSessionExpired) {
        sessionStorage.removeItem(SessionExpired.SESSION_EXPIRED);
        logout();
      }
    }, []);
    const handleContinue = () => {
      timer.current = new Date();
      setShowModal(false);
      setTimeLeft(timeLeftInSeconds); // Reset time left
      idleTimer.reset(); // Reset idle timer
      void updateToken();
    };

    const formatTime = (seconds: number) => {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    };

    useEffect(() => {
      if (showModal && timeLeft > 0) {
        sessionStorage.removeItem(SessionExpired.SESSION_EXPIRED);
        const interval = setInterval(() => {
          setTimeLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(interval);
      } else if (showModal && timeLeft === 0) {
        sessionStorage.setItem(SessionExpired.SESSION_EXPIRED, "true");
      }
    }, [showModal, timeLeft]);

    const handleOnIdle = () => {
      setShowModal(true);
      timer.current = new Date();
    };
    const handleOnAction = (event: any) => {
      timer.current = new Date();
    };
    const idleTimer = useIdleTimer({
      timeout: IDLE_TIME * 60 * 1000, // 20 minutes
      onIdle: handleOnIdle,
      onActive: handleOnAction,
      debounce: 500
      // disabled: !isAuthenticated || !isPrivacyConsented,
    });
    const logout = () => {
      setShowModal(false);
      if (!(window.location.hostname === "localhost")) {
        clearLocalData();
        sessionStorage.removeItem(SESSION_STORAGE_VAR.localAuthToken);
        sessionStorage.removeItem(SESSION_STORAGE_VAR.userDetails);
        sessionStorage.removeItem(SessionExpired.SESSION_EXPIRED);
        setTimeout(
          () => (window.location.href = ENV_VARS?.KF_TALENT_SUITE + "/logout"),
          800
        );
      }
    };

    const updateAuth = (authToken: string) => {
      kf1AuthenticatedHttpClient.interceptors.request.clear();
      kf1AuthenticatedHttpClient.interceptors.request.use((config) => {
        if (authToken) {
          // config.headers.authtoken = `${authToken}`;
          // config.timeout = API_TIMEOUT;
          // sessionStorage.setItem(SESSION_STORAGE_VAR.localAuthToken, authToken);
          config.headers.Authorization = `Bearer ${authToken}`;
          sessionStorage.setItem(SESSION_STORAGE_VAR.localAuthToken, authToken);
        }
        config = KfSessionBaggageInterceptor(config);
        return config;
      });
    };

    const updateToken = async () => {
      const res: any = await refreshAuthToken(); // refresh token if user is not active within 15 minutes
      // timerRef.current = new Date();
      if (res?.access_token) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        updateAuth(res.access_token);
        sessionStorage.setItem(
          SESSION_STORAGE_VAR.refreshToken,
          res?.refresh_token
        );
      }
    };
    const clearLocalData = () => {
      resetPeerGroups();
      dispatch(resetState());
      dispatch(resetFilters());
      dispatch(resetFiltersCount());
      dispatch(resetJobCatogery());
      dispatch(resetJobPricingList());
      dispatch(resetSearchKey());
      dispatch(resetPeerGroupId());
      dispatch(resetStateClient());

      dispatch(resetConfigState());

      dispatch(resetCurrencyState());
      dispatch(resetFilterState());
      dispatch(resetReportDetailsState());
      dispatch(resetReportSearchState());

      dispatch(resetJobPricingState());

      dispatch(resetReportsState());

      dispatch(resetUserState());
    };

    // const [timer, setTimer] = useState<Date>(new Date());
    const timer = useRef(new Date());

    const interval = REFRESH_AUTH_TOKEN_INTERVEL * 60 * 1000;
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

    useEffect(() => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      intervalRef.current = setInterval(() => {
        if (timer.current) {
          var endTime = new Date();
          var difference = endTime.getTime() - timer.current.getTime(); // This will give difference in milliseconds
          var idleTime = Math.round(difference / 60000);

          // if (idleTime >= IDLE_TIME) {
          //   setShowModal(true);
          timer.current = new Date();
          // }
        }
      }, 1000); // update token in interval
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }, []);

    return (
      <>
        <WrappedComponent {...props} />

        {showModal && (
          <ODSModal
            id="session-idle-modal"
            className="session-idle-modal"
            isOpen={showModal}
            maxWidth="500px"
            width="500px"
            onClose={logout}
            title={
              timeLeft === 0 ? t("sessionExpiredShort") : t("continuePrompt")
            }
            bodyContent={
              <p>
                {timeLeft === 0 ? (
                  t("sessionExpired")
                ) : (
                  <>
                    {t("expiryWarning")} <b>{formatTime(timeLeft)}</b>
                  </>
                )}
              </p>
            }
            footerButtons={{
              cancelButtonLabel: timeLeft === 0 ? "Ok" : "Logout",
              cancelButtonVariant:
                timeLeft === 0 ? ButtonTheme.Primary : ButtonTheme.Secondary,
              onCancel: logout,
              successButtonLabel: timeLeft > 0 ? "Yes, Continue" : undefined,
              onSuccess: timeLeft > 0 ? handleContinue : undefined
            }}
          />
        )}
      </>
    );
  };
};

export default withSessionManager;
